// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "../../Social.telemetry";

export interface PublisherProfileTabsTelemetryObjects {
    mainItem: TelemetryObjectBase;
    tabs: any;
}

export const publisherProfileTabsTelemetryContracts = {
    mainItem: {
        name: "PublisherProfile",
        content: {
            type: TelemetryContentType.Profile
        }
    },
    /** Click Tab */
    tabs: {
        All: { /** id: traceId */
            name: "All",
            behavior: TelemetryBehaviorType.Show,
            content: {
                headline: "All",
                type: TelemetryContentType.Profile
            }
        },
        Premium: { /** id: traceId */
            name: "Premium",
            behavior: TelemetryBehaviorType.Show,
            content: {
                headline: "Premium",
                type: TelemetryContentType.Profile
            }
        }
    }
};

export const publisherProfileTabsTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    tabClicked: genericTelemetryClickDispatcher
};